import { icons } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/games_panel.css */
  .menu_select {
    width: 18px;
    height: 18px;
    background: hsla(0, 0%, 0%, 0.2) url(${icons.arrow_up}) center 4px / auto 9px no-repeat;
    filter: invert(1);
    border-radius: 3px;
    cursor: pointer;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/lb_bids_stats.css */
  .stats_tabs_wrapper .panel {
    display: none;
    animation: fadein 0.8s;
    width: 100%;
    padding: 0;
    background: transparent;
    flex-flow: row;
  }
  .stats_tabs_wrapper #stats_tabs_one:checked ~ .panels #one-panel {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  }
  .table_wrapper {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    position: relative;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    margin: 15px 0 0 0;
    height: calc(35vh - 70px);
  }
  .table_wrapper .grid-body.your_bids_iw {
    display: grid;
    grid-template-columns: 0.25fr 1fr 0.75fr 1fr 1fr 1fr 0.55fr 0.75fr 1fr 1fr 0.5fr 0.25fr 0.25fr 0.25fr;
    overflow: auto;
    width: 100%;
  }
  .table_wrapper .grid-header {
    display: contents;
  }
  .grid-body .grid-content {
    display: contents;
  }
  .table_wrapper .grid-body label {
    padding: 12px 6px 10px 6px;
    border-bottom: 1px solid var(--bidding-table-cell-border);
    font-size: 0.7rem;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-weight: 500;
    opacity: 1;
  }
  .table_wrapper .grid-header label {
    backdrop-filter: blur(20px);
    background: var(--bidding-table-header-background);
    position: sticky;
    top: 0%;
    font-size: 0.75rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    white-space: nowrap;
    border-top: 1px solid transparent;
    /* cursor: pointer; */
    font-weight: 600;
    z-index: 1;
    opacity: 1;
  }
  .table_wrapper .grid-header label span {
    color: hsl(214, 5%, 50%);
    font-weight: 600;
    font-size: 0.75rem;
  }
  .table_wrapper .grid-header label:hover {
    border-top: 1px solid var(--primary-active);
    color: hsl(214, 5%, 80%);
    /* color: hsl(0, 0%, 100%); */
  }
  .table_wrapper .grid-header label:hover span {
    color: hsl(0, 0%, 100%);
  }
  .table_wrapper .grid-header label.status {
    padding-left: 15px;
  }
  .table_wrapper .grid-content label {
    color: #fff;
    z-index: 0;
    position: relative;
    min-height: 60px;
  }
  .table_wrapper .grid-content .asset .asset_icon {
    margin: 0 5px 0 0;
  }
  .table_wrapper .grid-content label.asset span {
    color: inherit;
    padding-top: 3px;
  }
  .table_wrapper .grid-content label.status {
    padding-left: 15px;
  }
  .table_wrapper .grid-content label.open.profit {
    color: #fff;
    background: hsla(126, 100%, 38%, 0.25);
    border-bottom: 1px solid hsla(126, 100%, 38%, 0.25);
    opacity: 1;
  }
  .table_wrapper .grid-content label.open.loss {
    color: #fff;
    background: hsla(340, 88%, 46%, 0.25);
    border-bottom: 1px solid hsla(340, 88%, 46%, 0.25);
    opacity: 1;
  }
  .table_wrapper .grid-content label.status.open.profit span {
    color: hsla(126, 100%, 38%, 1);
  }
  .table_wrapper .grid-content label.status.open.loss span {
    color: hsla(340, 88%, 46%, 1);
  }
  .table_wrapper .grid-content label.action_status .cashout {
    border-radius: 10px;
    padding: 8px 10px 7px 30px;
    font-size: 0.7rem;
    white-space: nowrap;
    text-transform: uppercase;
    line-height: 100%;
    display: flex;
    font-weight: 600;
  }

  .table_wrapper .grid-content label.action_status.grayout .cashout {
    filter: grayscale(1);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .table_wrapper .grid-content label.action_status.open.profit .cashout {
    background: linear-gradient(180deg, #153a1b, #14381a, #143719, #133518, #133318, #123117, #123016, #112e15);
    border: 1px solid hsla(126, 100%, 28%, 0.4);
  }
  .table_wrapper .grid-content label.action_status.open.profit .cashout:before {
    background: url(${icons.cashout_icon_green}) left center / 12px auto no-repeat;
    width: 12px;
    height: 12px;
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    content: '';
  }
  .table_wrapper .grid-content label.action_status.open.profit .cashout:hover {
    background: hsla(126, 100%, 28%, 0.5) url(${icons.cashout_icon_green}) 10px center / 12px auto no-repeat;
  }

  .table_wrapper .grid-content label.action_status.open.loss .cashout {
    background: linear-gradient(180deg, #53182b, #4f1729, #4c1627, #481525, #451424, #411322, #3d1220, #3a111e);
    border: 1px solid hsla(340, 88%, 46%, 0.4);
  }
  .table_wrapper .grid-content label.action_status.open.loss .cashout:before {
    background: url(${icons.cashout_icon_red}) left center / 12px auto no-repeat;
    width: 12px;
    height: 12px;
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    content: '';
  }

  .table_wrapper .grid-content label.share_bid button:before {
    mask: url(${icons.twitter_icon}) center center / 12px auto no-repeat;
    background: #fff;
    width: 12px;
    height: 12px;
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    content: '';
  }

  .table_wrapper .grid-content label.action_status.open.loss .cashout:hover {
    background: hsla(340, 88%, 46%, 0.5) url(${icons.cashout_icon_red}) 10px center / 12px auto no-repeat;
  }

  .table_wrapper .grid-content label.status.closed span {
    color: inherit;
    line-height: 140%;
  }
  .table_wrapper .grid-content label.status.closed img {
    width: 10px;
    height: 10px;
    margin: 0 5px 0 0;
  }
  .table_wrapper .grid-content label.status.open img {
    width: 16px;
    height: 16px;
    margin: 0 5px 0 0;
  }
  .table_wrapper .grid-content label.action_status {
    padding-top: 6px;
    padding-bottom: 5px;
    /* padding-right: 30px; */
  }

  .table_wrapper .grid-content label.result.busted {
    color: hsl(340, 88%, 46%);
    padding-left: 26px;
    text-transform: uppercase;
    font-size: 0.7rem;
    background-image: url(${icons.busted_icon});
    background-position: 6px center;
    background-size: 15px auto;
    background-repeat: no-repeat;
  }
  .table_wrapper .grid-content label.result.busted span {
    color: hsl(340, 88%, 46%);
  }
  .table_wrapper .grid-content label.result.cashed_out.profit {
    color: hsl(126, 100%, 38%);
    padding-left: 26px;
    text-transform: uppercase;
    font-size: 0.7rem;
    background-image: url(${icons.cashed_out_icon_profit});
    background-position: 6px center;
    background-size: 15px auto;
    background-repeat: no-repeat;
  }
  .table_wrapper .grid-content label.result.cashed_out.profit span {
    color: hsl(126, 100%, 38%);
  }
  .table_wrapper .grid-content label.result.cashed_out.loss {
    color: hsl(340, 88%, 46%);
    padding-left: 26px;
    text-transform: uppercase;
    font-size: 0.7rem;
    background-image: url(${icons.cashed_out_icon_loss});
    background-position: 6px center;
    background-size: 15px auto;
    background-repeat: no-repeat;
  }
  .table_wrapper .grid-content label.result.cashed_out.loss span {
    color: hsl(340, 88%, 46%);
  }

  .table_wrapper .grid-content label.result.funding.profit {
    color: hsl(126, 100%, 38%);
    padding-left: 26px;
    text-transform: uppercase;
    font-size: 0.7rem;
    background-image: url(${icons.funding_order_icon_profit});
    background-position: 6px center;
    background-size: 15px auto;
    background-repeat: no-repeat;
  }
  .table_wrapper .grid-content label.result.funding.profit span {
    color: hsl(126, 100%, 38%);
  }
  .table_wrapper .grid-content label.result.funding.loss {
    color: hsl(340, 88%, 46%);
    padding-left: 26px;
    text-transform: uppercase;
    font-size: 0.7rem;
    background-image: url(${icons.funding_order_icon_loss});
    background-position: 6px center;
    background-size: 15px auto;
    background-repeat: no-repeat;
  }
  .table_wrapper .grid-content label.result.funding.loss span {
    color: hsl(340, 88%, 46%);
  }

  .table_wrapper .grid-content label.pandl {
    white-space: nowrap;
  }
  .table_wrapper .grid-content label.pandl.down,
  .table_wrapper .grid-content label.roi.down {
    color: hsl(340, 88%, 46%);
  }
  .table_wrapper .grid-content label.pandl.up,
  .table_wrapper .grid-content label.roi.up {
    color: hsl(126, 100%, 38%);
  }
  .table_wrapper .grid-content label.up {
    color: hsl(126, 100%, 38%);
  }
  .table_wrapper .grid-content label.down {
    color: hsl(340, 88%, 46%);
  }
  .table_wrapper .grid-content label.tpsl {
    font-size: 0.7rem;
    line-height: 120%;
    padding: 6px 10px;
  }
  .table_wrapper .grid-content label.tpsl button.edit_tpsl {
    background: hsla(0, 0%, 100%, 0.1) url(${icons.edit_icon}) center center / 9px auto no-repeat;
    margin: 0 0 0 5px;
    padding: 10px;
    border-radius: 6px;
  }
  .table_wrapper .grid-content label.tpsl:hover button.edit_tpsl {
    background-color: hsla(0, 0%, 100%, 0.2);
  }
  .table_wrapper .grid-header label .menu_select {
    width: 17px;
    height: 17px;
    background: hsla(0, 0%, 0%, 0.2) url(${icons.arrow_up}) center 3px / auto 10px no-repeat;
    filter: invert(1) brightness(0.4);
    margin: 0 0 0 6px;
  }
  .table_wrapper .grid-header label:hover .menu_select {
    filter: invert(1) brightness(1);
  }
  .asset .asset_icon {
    height: 14px;
    width: 14px;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .asset .asset_icon img {
    height: 14px;
  }
  .bid_direction {
    mask: url(${icons.bid_direction_icon}) center center / auto 14px no-repeat;
    width: 14px;
    height: 14px;
    margin: 0 3px 0 0;
  }
  .bid_direction.above {
    background: hsl(126, 100%, 38%);
    transform: rotate(180deg);
  }
  .table_wrapper .yourbids_table_row {
    display: contents;
  }
  .table_wrapper .yourbids_table_row:hover > label {
    background-color: hsla(0, 0%, 100%, 0.05);
    color: #fff;
    /* cursor: pointer; */
    opacity: 1;
  }
  .table_wrapper .yourbids_table_row:hover > label.open.profit {
    background-color: hsla(126, 100%, 38%, 0.15);
  }
  .table_wrapper .yourbids_table_row:hover > label.open.loss {
    background-color: hsla(340, 88%, 46%, 0.2);
  }

  @media (max-width: 1700px) {
    .table_wrapper .grid-header label.status span {
      display: none;
    }
    .table_wrapper .grid-header label.asset span {
    }

    .table_wrapper .grid-content label.status span {
      display: none;
    }
  }

  @media (max-width: 1200px) {
    .table_wrapper .grid-body label {
      padding: 12px 4px 10px 4px;
    }
    .table_wrapper .grid-header label.status {
      padding-left: 15px;
    }
    .table_wrapper .grid-content label.status {
      padding-left: 15px;
    }
    .table_wrapper .grid-content label.action_status {
      padding-right: 15px;
    }
    .table_wrapper .grid-body.your_bids_iw {
      grid-template-columns: 0.25fr 1fr 0.75fr 1fr 1fr 1fr 1fr 1fr 0.5fr 0.25fr 0.25fr 0.25fr 1fr;
    }
    .table_wrapper .grid-body label.tpsl {
      display: none;
    }
  }
  @media (max-width: 1000px) {
    .table_wrapper .grid-body.your_bids_iw {
      grid-template-columns: 0.25fr 1fr 0.75fr 1fr 1fr 0.5fr 0.25fr 0.25fr 0.25fr 1fr;
    }
    .table_wrapper .grid-body label.tpsl,
    .table_wrapper .grid-body label.bust,
    .table_wrapper .grid-body label.exit,
    .table_wrapper .grid-body label.multiplier {
      display: none;
    }
  }
  @media (max-width: 800px) {
    .table_wrapper {
      height: calc(35vh - 67px);
    }
    .table_wrapper .grid-body.your_bids_iw {
      grid-template-columns: 0.25fr 0.75fr 1fr 1fr 0.5fr 0.25fr 0.25fr 0.25fr 1fr;
    }
    .table_wrapper .grid-body label.tpsl,
    .table_wrapper .grid-body label.entry,
    .table_wrapper .grid-body label.bust,
    .table_wrapper .grid-body label.exit,
    .table_wrapper .grid-body label.multiplier {
      display: none;
    }
  }
  @media (max-width: 600px) {
    .table_wrapper .grid-body.your_bids_iw {
      grid-template-columns: 0.25fr 0.25fr 1fr 1fr 0.25fr 0.25fr 0.25fr 0.25fr;
    }
    .table_wrapper .grid-content label.action_status.open.profit button.cashout,
    .table_wrapper .grid-content label.action_status.open.loss button.cashout,
    .table_wrapper .grid-content label.result.cashed_out span,
    .table_wrapper .grid-content label.result.busted span {
      display: none;
    }
    .table_wrapper .grid-content label.result.busted,
    .table_wrapper .grid-content label.result.cashed_out.profit,
    .table_wrapper .grid-content label.result.cashed_out.loss {
      padding-left: 0;
      background-position: center center;
      background-size: 18px auto;
    }
    .table_wrapper .grid-content label.action_status.open.profit button.cashout_icon,
    .table_wrapper .grid-content label.action_status.open.loss button.cashout_icon {
      display: flex;
    }
    .table_wrapper .grid-content label.status span {
      display: none;
    }
    .table_wrapper .grid-content label.status.open img {
      margin: 0;
    }
    .table_wrapper .grid-header label.status {
      padding-left: 10px;
    }
    .table_wrapper .grid-content label.action_status {
      padding-right: 10px;
      justify-content: center;
    }
    .table_wrapper .grid-header label.status span,
    .table_wrapper .grid-header label.asset span {
      display: none;
    }
    .table_wrapper .grid-header label.status .menu_select,
    .table_wrapper .grid-header label.asset .menu_select {
      margin: 0;
    }
    .table_wrapper .grid-content label.asset span {
      display: none;
    }
    .asset .asset_icon img {
      height: 18px;
    }
  }
  @media (max-width: 430px) {
    .table_wrapper .grid-content label.status {
      padding-left: 5px;
    }
    .table_wrapper .grid-content label.action_status {
      padding-right: 5px;
    }
    .table_wrapper .grid-body.your_bids_iw {
      grid-template-columns: 0.25fr 0.25fr 0.25fr 0.5fr 0.5fr 0.25fr 0.25fr;
    }
    .table_wrapper .grid-header label.bidamount span,
    .table_wrapper .grid-content label.bidamount span {
      display: none;
    }
    .table_wrapper .grid-header label.bidamount .menu_select {
      margin: 0;
    }
  }
  /*! CSS Used keyframes */
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`
const developerCSS = css`
  .bid_direction.below {
    background: hsl(340, 88%, 46%);
  }
  .table_wrapper .grid-content label.action_status .cashout {
    min-width: 103px;
  }
  .table_wrapper .grid-content label.action_status.pending {
    /* color: hsl(340, 88%, 46%); */
    padding-left: 6px;
    text-transform: uppercase;
    font-size: 0.7rem;
  }
  .table_wrapper .grid-content label.action_status.loss.pending span {
    color: hsl(340, 88%, 46%);
  }
  .table_wrapper .grid-content label.action_status.profit.pending span {
    color: hsl(126, 100%, 38%);
  }
  @media (max-width: 600px) {
    .table_wrapper .grid-content label.action_status.pending span {
      display: none;
    }
    .table_wrapper .grid-content label.action_status.pending {
      padding-left: 0;
      background-position: center center;
      background-size: 18px auto;
    }
  }
`
const bidCloningCSS = css`
  .table_wrapper .grid-content label.bid_cloning_ind {
    position: relative;
    display: flex;
    padding-right: 15px;
  }
  .table_wrapper .grid-content label.bid_cloning_ind:before {
    display: flex;
    position: absolute;
    content: '';
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    align-items: center;
    justify-content: center;
    background: url(${icons.clone_bid_icon}) center center / auto 12px no-repeat;
    width: 12px;
    height: 12px;
  }
`
const bidInfoButtonCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/lb_bids_stats.css */
  .table_wrapper .yourbids_table_row:hover > label.status:not(.pending) img,
  .table_wrapper .yourbids_table_row:hover > label.status:not(.pending) span {
    display: none;
  }

  .table_wrapper .grid-body .grid-content label.status .bid_information {
    display: none;
    width: 100%;
    height: 100%;
  }
  .table_wrapper .yourbids_table_row:hover > label.status .bid_information {
    display: flex;
    width: 100%;
    height: 100%;
    text-align: center;
    justify-content: center;
    align-items: center;
    font-size: 0.6rem;
    white-space: nowrap;
    font-weight: 600;
    background: #000;
    border-radius: 6px;
    padding: 10px 0;
    position: relative;
    cursor: pointer;
  }
  .table_wrapper .yourbids_table_row:hover > label.status.open.profit .bid_information {
    background: linear-gradient(180deg, #008f0e, #008c0e, #00890d, #00850d, #00820d, #007f0d, #007c0c, #00790c);
  }
  .table_wrapper .grid-body .grid-content label.status.open.profit .bid_information:hover {
    background: linear-gradient(180deg, #008f0e, #008c0e, #008c0e, #008c0e, #008c0e, #008c0e, #008c0e, #008c0e);
  }
  .table_wrapper .yourbids_table_row:hover > label.status.open.loss .bid_information {
    background: linear-gradient(180deg, #d20e4f, #cc0e4d, #c60d4a, #c00d48, #ba0c46, #b40c44, #ae0b41, #a80b3f);
  }
  .table_wrapper .grid-body .grid-content label.status.open.loss .bid_information:hover {
    background: linear-gradient(180deg, #d20e4f, #d20e4f, #d20e4f, #d20e4f, #d20e4f, #d20e4f, #d20e4f, #d20e4f);
  }
  .table_wrapper .yourbids_table_row:hover > label.status.closed .bid_information {
    background: linear-gradient(180deg, #808080, #7b7b7b, #767676, #717171, #6c6c6c, #686868, #636363, #5e5e5e);
  }
  .table_wrapper .grid-body .grid-content label.status.closed .bid_information:hover {
    background: linear-gradient(180deg, #808080, #808080, #808080, #808080, #808080, #808080, #808080, #808080);
  }
  .table_wrapper .yourbids_table_row:hover > label.status .bid_information:before {
    content: 'BID INFO';
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const YourBidsCSS = styled.div`
  ${designerCSS}
  ${bidCloningCSS}
  ${bidInfoButtonCSS}
  ${developerCSS}
`
